import { useMutation } from '@gogame/query';

import { upload } from '../queryKeyFactory';

import { uploadMasterCampaign } from 'scenes/Influencers/MasterCampaigns/sources/masterCampaigns';

export const useUploadMasterCampaign = () => {
  const uploadMutation = useMutation(upload(), uploadMasterCampaign, {
    successMessage: () => {
      return `We started the process of campaign creation. It might take several hours. We will email you the file with the campaigns are ready`;
    },
  });

  return [uploadMutation.mutateAsync, uploadMutation];
};
